<template>
  <div class="number-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'" :for="options.name">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'NumberInput',
  props: {
    value: {
      type: [Number, String]
    },
    options: {
      type: Object,
      default () {
        return {
          value: ''
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      isLength: false,
      isRegex: false,
      regex: /^[0-9]+$/,
      invalidMessage: 'The number entered is not valid'
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    this.validate(this.value)
  },
  methods: {
    validate (val = this.value) {
      val = val === undefined ? '' : val
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = !Number.isNaN(Math.floor(val)) && val !== ''
        this.isLength = val.length >= this.minLength
      } else {
        this.isDirty = val && val !== ''
        this.isValid = !Number.isNaN(Math.floor(val))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/NumberInput.vue